import { Box } from "@mui/material";
import { MarketResearchStudy } from "../models";
import InterviewComponent from "./InterviewComponent";
import SideMenuItem from "./SideMenuItem";

interface MenuItemConfig {
  label: string;
  icon: React.ReactNode;
  rightIcon?: React.ReactNode;
  show?: boolean;
  isLoading?: boolean;
  onClick: () => void;
}

interface StudyRightPanelBaseProps {
  study: MarketResearchStudy;
  menuItems: MenuItemConfig[];
  showNoOfRespondents: boolean;
}

export default function StudyRightPanelBase({ study, menuItems, showNoOfRespondents }: StudyRightPanelBaseProps) {
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem", height: "93%" }}>
        {study && <InterviewComponent study={study} />}
        {menuItems
          .filter((item) => item.show !== false) // default show=true
          .map((item, index) => (
            <SideMenuItem key={index} icon={item.icon} rightIcon={item.rightIcon} onClick={item.onClick}>
              {item.label}
            </SideMenuItem>
          ))}
      </Box>
    </>
  );
}
